import { IconCheck } from '@tabler/icons-react'
import classNames from 'classnames'
import React, {
  MouseEvent,
  useCallback,
} from 'react'

import s from './radio.module.css'

export interface RadioProps {
  value: boolean
  onChange?: (value: boolean, event: MouseEvent<HTMLElement>) => void
  borderColor?: string
  className?: string
  size?: number
}

export default function Radio({
  value,
  onChange,
  borderColor = '#999',
  className,
  size = 24,
}: RadioProps) {
  const toggle = useCallback((event: MouseEvent<HTMLElement>) => {
    onChange?.(!value, event)
  }, [onChange, value])

  return (
    <div
      className={classNames(s.Radio, className, { [s.checked]: value })}
      style={{
        borderColor: !value ? borderColor : undefined,
        width: size,
        height: size,
        color: borderColor,
        fontSize: size,
      }}
      onClick={toggle}
    >
      {value && <IconCheck style={{ color: 'white' }} />}
    </div>
  )
}
